
import { defineComponent } from 'vue';

import Form from '@/shared/mixins/Form';
import { accountService } from './AccountService';

export default defineComponent({
  name: 'UserBasicProfile',
  mixins: [Form],
  data() {
    return {
      profile: {
        lastName: '',
        email: '',
      },
    };
  },
  async created() {
    this.isLoading = true;
    try {
      const result = await accountService.getProfile();
      this.profile = result.data;
    } catch (error) {
      console.error(error);
    }
  },
  methods: {},
});
